import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { EventModalClose } from './iti-modal-events';

@Component({
    // $_veeValidate: { validator: 'new' },
})
export default class ItiBaseModal extends Vue {
    public reset() {
        // this.$validator.reset();
    }

    protected validate(): Promise<any> {
        // return this.$validator.validateAll();
        return Promise.resolve(true);
    }

    protected async validateAndClose(returnData?: any) {
        const allOk = await this.validate();
        if (allOk) {
            this.closeModal(returnData);
        }
    }

    protected closeModal(returnData?: any) {
        this.$emit(EventModalClose, returnData);
    }
}
